import React, { FC } from 'react';
import { OnboardingPage } from './OnboardingPage';

export const PelitasOnboardingPage: FC = (): JSX.Element => <OnboardingPage pelitas={true} />;
